import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Axios from "axios";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

import { useStyles } from "./UserAssignments.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import SyllabusIcon from "../../../Assets/Logo/SyllabusIcon.svg";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import ViewAssignment from "./Assignment/ViewAssignment/ViewAssignment";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PdfReader from "../../../Components/PDFReader/PdfReader";
import { publicImageUrl } from "../../../Config/publicImageUrl";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserAssignments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assignments: [],
      currentDate: moment(new Date()).format("YYYY-MM-DD"),
      subject: "",
      pdfStatus: false,
      fileUrl: "",
      title: "",
    };
  }

  componentDidMount() {
    this.getUserAssignments();
  }

  getUserAssignments = async () => {
    try {
      if (this.props.role === "Student" || this.props.role === "Parent") {
        const responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        const response = await Axios.get(`${url}/api/assignments`, {
          params: {
            session: responseStudent.data.student.currentSession,
            studentClass: responseStudent.data.student.studentClass,
            faculty: responseStudent.data.student.faculty
              ? responseStudent.data.student.faculty
              : "",
            group: responseStudent.data.student.group
              ? responseStudent.data.student.group
              : "",
            section: responseStudent.data.student.section,
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        if (response.data.assignments.length !== 0) {
          this.setState({
            assignments: response.data.assignments,
            isEmpty: false,
          });
        } else {
          this.setState({
            assignments: [],
            isEmpty: true,
          });
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserAssignments();
      }
    }
  };

  handlePdfStatus = (subject, fileUrl, title) => {
    this.setState({ pdfStatus: true, subject, fileUrl, title });
  };
  handleCancelPdfStatus = () => {
    this.setState({ pdfStatus: false });
  };

  render() {
    const { classes } = this.props;
    let filtered = this.state.assignments.filter((data) => {
      return (
        moment(data.createdAt).format("YYYY") ===
          moment(this.state.currentDate).format("YYYY") &&
        moment(data.createdAt).format("MM") ===
          moment(this.state.currentDate).format("MM") &&
        moment(data.createdAt).format("DD") ===
          moment(this.state.currentDate).format("DD")
      );
    });
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="Assignments" refreshUrl={this.props.match.url} />
          </div>
          {this.props.role === "Teacher" ? (
            <ViewAssignment />
          ) : (
            <div>
              <TextField
                name="currentDate"
                type="date"
                required
                fullWidth
                label="Assignment Date"
                variant="outlined"
                margin="normal"
                className={classes.inputWithoutMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.currentDate}
                onChange={(e) => this.setState({ currentDate: e.target.value })}
              />
              <div>
                Assignment Date: {moment(this.state.currentDate).format("LL")}
              </div>
              <br />
              {this.state.pdfStatus ? (
                <div>
                  <ListItem>
                    <b>Subject:</b> {this.state.subject}
                  </ListItem>
                  <ListItem>
                    <b>Title:</b>
                    {this.state.title}
                  </ListItem>
                  <PdfReader
                    fileUrl={this.state.fileUrl}
                    title={this.state.title}
                    handleCancelPdfStatus={this.handleCancelPdfStatus}
                  />
                </div>
              ) : filtered.length !== 0 ? (
                <Grid container spacing={3}>
                  {filtered.map((data, index) => (
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4} key={index}>
                      <Paper className={classes.paper}>
                        <ListItem>
                          <b>{data.subject}</b>
                        </ListItem>
                        <ListItem>
                          <div>
                            Deadline:-
                            {moment(data.submissionDate).format("LL")}
                          </div>
                        </ListItem>
                        {data.files.map((file, index) => (
                          <Tooltip
                            key={index}
                            arrow
                            title={`${data.title}`}
                            className={classes.tooltip}
                            onClick={() =>
                              this.handlePdfStatus(
                                data.subject,
                                `${publicImageUrl}/${file}`,
                                `${data.title}`
                              )
                            }
                          >
                            <img
                              src={SyllabusIcon}
                              alt="Syllabus"
                              style={{ width: 80, height: 80 }}
                            />
                          </Tooltip>
                        ))}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <CustomEmptyMessage description="No any assignment for today" />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserAssignments));
